// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDGKZpqOer4mFc8sPlmktswVCAdyiGYDa0",
  authDomain: "supramax-48729.firebaseapp.com",
  projectId: "supramax-48729",
  storageBucket: "supramax-48729.appspot.com",
  messagingSenderId: "892002159170",
  appId: "1:892002159170:web:85d904ce1743e28509bbdb",
  measurementId: "G-YM2W287XBM",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app